import * as helper from './../../../Assets/Js/helper';
import * as Events from './Events';

export default class Hostline {
	constructor() {
		this.line = document.getElementById('hostInfo');
		this.currentName = '';
		helper.addEventListener(window, Events.VIDEO_CHANGED, this._hideName.bind(this));
		helper.addEventListener(window, Events.VIDEO_STARTED_PLAYING, this._changeName.bind(this));
		helper.addEventListener(this.line, 'click', () => {
			helper.triggerEvent(window, Events.CREATE_SIGNUP);
		});
	}

	_hideName(event) {
		this.line.innerHTML = 'Suche nach einem hei&szlig;en Girl...';
		this.currentName = event.detail.name;
	}

	_changeName() {
		this.line.innerHTML = `Verbindung eingerichtet mit <a href="#" class="paytour">${this.currentName}</a>`;
	}
}
